import type { AttributionData } from './types';

type SearchParams = Record<string, string | string[] | undefined>;

const readString = (
  value: string | string[] | undefined,
): string | undefined => {
  const first = Array.isArray(value) ? value[0] : value;
  if (typeof first === 'string' && first.length > 0) return first;
  return undefined;
};

export const parseAttribution = (
  params: SearchParams,
): AttributionData | null => {
  const gclid = readString(params.gclid);
  const gbraid = readString(params.gbraid);
  const wbraid = readString(params.wbraid);
  const utmSource = readString(params.utm_source);
  const utmMedium = readString(params.utm_medium);
  const utmCampaign = readString(params.utm_campaign);
  const utmTerm = readString(params.utm_term);
  const utmContent = readString(params.utm_content);

  const hasAny =
    gclid ||
    gbraid ||
    wbraid ||
    utmSource ||
    utmMedium ||
    utmCampaign ||
    utmTerm ||
    utmContent;

  if (!hasAny) return null;

  return {
    gclid,
    gbraid,
    wbraid,
    utmSource,
    utmMedium,
    utmCampaign,
    utmTerm,
    utmContent,
    capturedAt: Date.now(),
  };
};
